// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"580":"b8330fd8","4604":"12529ca1","5930":"17090d73","6983":"dad308c2","8180":"17090d73","9048":"afa358c6"}[chunkId] + ".css";
};